import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { queryKeyMap } from "@/features/query-client";

import { type IUpdateLenderCompanyInput, updateLenderCompany } from "../api";

type IUpdateLenderCompanyMutationResponse = Awaited<
  ReturnType<typeof updateLenderCompany>
>;

interface IUpdateLenderCompanyMutationVariables {
  lenderCompanyId: number;
  data: IUpdateLenderCompanyInput;
}

export const useUpdateLenderCompanyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<
    IUpdateLenderCompanyMutationResponse,
    AxiosError,
    IUpdateLenderCompanyMutationVariables
  >({
    mutationKey: ["update-lender-company"],
    mutationFn: async (variables: IUpdateLenderCompanyMutationVariables) => {
      return await updateLenderCompany(
        variables.lenderCompanyId,
        variables.data,
      );
    },
    onSuccess: (data, variables) => {
      queryClient.setQueryData(
        queryKeyMap.getLenderCompany(variables.lenderCompanyId),
        data,
      );
    },
  });
};
